import React from 'react'

import ClientLogosSlider from '../../../blocks/TwoCols/ClientLogosSlider'

import '../../../containers/formHero.scss'

const FormHero = ({
    className = '',
    titleId,
    overtitle,
    title,
    description,
    form,
}) => (
    <section className={`hero form-hero-v1 form-hero-scoped ${className}`} aria-labelledby={titleId}>
        <div className="form-hero-v1__main">
            <div className="form-hero-v1__content">
                <span className="overtitle form-hero-v1__overtitle">
                    {overtitle}
                </span>
                <h1 className="title form-hero-v1__title" id={titleId}>{title}</h1>
                <h2 className="description form-hero-v1__description">{description}</h2>
                <div className="form-hero-v1__rating" aria-label="Avaliação: 4,8 de 5 estrelas">
                    <div className="form-hero-v1__rating-line">
                        <span className="form-hero-v1__stars" aria-hidden="true">★★★★★</span>
                        <span aria-hidden="true">4,8</span>
                    </div>
                    <p className="form-hero-v1__rating-text">12.255 Avaliações reais no <strong>Google Play</strong>, <strong>App Store</strong> e <strong>Google Meu Negócio</strong></p>
                </div>
            </div>
            <div className="form-hero-v1__form">
                {form}
            </div>
        </div>
        <ClientLogosSlider className="hero-form-logo-strip" hideHeader />
    </section>
)

export default FormHero



// WEBPACK FOOTER //
// /usr/src/site-blog/src/components/site/FormHero/FormHero.jsx